import React, { Component } from 'react';
import { Provider } from 'react-redux';
import './App.css';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import Login from './components/account/Login';
import Confirm from './components/account/Confirm';
import Paystubs from './components/Paystubs';
import TaxDocuments from './components/TaxDocuments';
import Profile from './components/account/Profile';
import NotFound from './components/common/NotFound';
import F1095C from './components/F1095C';
import ResetPassword from './components/account/ResetPassword';
import ConfirmNewEmail from './components/account/ConfirmNewEmail';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

//Polyfills for IE
import 'core-js/es6/number';
import 'core-js/es6/array';

//configuration
const hostname = window && window.location && window.location.hostname;
if (hostname === 'hub.computerease.com') {
  window.CE_HUB_API_URL = 'https://api.hub.computerease.com';
} else if (hostname === 'stage.hub.computerease.com') {
  window.CE_HUB_API_URL = 'https://stage.api.hub.computerease.com';
} else {
  window.CE_HUB_API_URL =
    process.env.REACT_APP_BACKEND_HOST || 'http://localhost:8000';
}
const store = createStore(rootReducer, {}, applyMiddleware(thunk));

const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      localStorage.getItem('token') ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/',
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          <div>
            <Switch>
              <Route exact path="/" component={Login} />
              <Route
                path="/user/email/verify/:token"
                component={ConfirmNewEmail}
              />
              <Route path="/user/verify/:token" component={Confirm} />
              <ProtectedRoute path="/paystubs" component={Paystubs} />
              <ProtectedRoute path="/f1095c" component={F1095C} />
              <ProtectedRoute path="/taxes" component={TaxDocuments} />
              <ProtectedRoute path="/account" component={Profile} />
              <ProtectedRoute Route exact path="/logout" component={Login} />
              <Route
                path="/user/forgot/password/:token"
                component={ResetPassword}
              />
              <ProtectedRoute component={NotFound} />
            </Switch>
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js